import { render, staticRenderFns } from "./AlertHistorySearch.vue?vue&type=template&id=12a7e943&scoped=true"
import script from "./AlertHistorySearch.vue?vue&type=script&lang=js"
export * from "./AlertHistorySearch.vue?vue&type=script&lang=js"
import style0 from "./AlertHistorySearch.vue?vue&type=style&index=0&id=12a7e943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7e943",
  null
  
)

export default component.exports